export default __webpack_public_path__ + "static/media/Avanish.aa28d2fd.png";